export * from './FreezerIcon'
